module.exports = __webpack_public_path__ + "static/media/project5.5fb49117.jpg";